import React from 'react';
import { Button } from './ui/Button';

/**
 * Top-level error boundary: catches render errors anywhere in the tree
 * and shows a recoverable fallback instead of a white screen.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-surface text-text flex items-center justify-center px-xl">
          <div className="w-full max-w-[420px] bg-surface-raised border border-border rounded-lg shadow-md p-2xl text-center animate-scale-in">
            <div className="mx-auto mb-lg flex h-12 w-12 items-center justify-center rounded-pill bg-destructive-soft">
              <i className="bi bi-exclamation-triangle text-xl text-destructive" aria-hidden="true" />
            </div>
            <h1 className="text-section-title font-semibold text-text-strong mb-sm">
              Что-то пошло не так
            </h1>
            <p className="text-body-sm text-text-muted mb-xl">
              Произошла непредвиденная ошибка. Попробуйте перезагрузить страницу.
            </p>
            <Button
              variant="primary"
              size="md"
              icon="bi-arrow-clockwise"
              onClick={this.handleReload}
              className="mx-auto"
            >
              Перезагрузить
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
